import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import qs from 'qs';

import { Token, RefreshToken, Workspace, APIVersion } from '../constants/keys';

const baseUrl = `${import.meta.env.VITE_API_URL}`;


// standard query for rtk-query
const baseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: async (headers) => {
    const accessToken = localStorage.getItem(Token);
    const refreshToken = localStorage.getItem(RefreshToken);
    const workspaceId = localStorage.getItem(Workspace);

    if (accessToken && refreshToken) {
      headers.set('Authorization', `Bearer ${accessToken}`);
      headers.set('X-Workspace', workspaceId && workspaceId.length ? JSON.parse(workspaceId) : '');
      // headers.set('X-Workspace', JSON.parse(workspaceId) || DemoWorkspaceId);
    }

    return headers;
  },
  paramsSerializer: (params) => qs.stringify(params, { encode: false, skipNulls: true }),
});

// refresh-token query for rtk-query
export const baseQueryWithAuth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  const refresh = localStorage.getItem(RefreshToken);

  if (refresh && result.error && result.error.status === 401) {
    const { data } = await baseQuery(
      { url: `/iam-api/${APIVersion}/token-refresh`, method: 'POST', body: { refresh } },
      api,
      extraOptions,
    );

    if (data) {
      const { access } = data as { access: string };

      localStorage.setItem(Token, access);

      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch({ type: 'auth/logout' });
    }
  }

  return result;
};
